export default {
  'templates.tpl_vars_set_placeholder': 'Ensemble de variables',
  'templates.tpl_type_placeholder': 'Type de modèle',
  'templates.tokens': 'Jeton',
  'templates.tpl_vars_set': 'Ensemble de variables',
  'templates.tpl_type': 'Type de modèle',
  'templates.required_variables': 'Variables requises',
  'templates.to_create_template': 'Pour créer un modèle, allez ici',
  'templates.set_as_default_template': 'Définir comme modèle par défaut',
  'templates.this_required': 'Ce champ est obligatoire',
  'templates.mjml_tooltip': 'Collez le modèle mjml',
  'templates.is_default': 'Est le modèle par défaut',
  'code.snippet': "Essayez d'entrer @ pour l'auto-complétion",
};
